module.exports = __webpack_public_path__ + "static/media/arrow-down.6ee08e8f.svg";